import Link from 'components/ui/Link';
import styled from 'styled-components';
import {
  ADMIN_LINK,
} from 'style/mixins';

export default styled(Link)`
  ${ADMIN_LINK}
`;
